import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { Notifications } from './Notifications';
import { useAuth } from '../hooks/useAuth';
import clsx from 'clsx';

interface HeaderProps {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
}

export function Header({ isSidebarOpen, toggleSidebar }: HeaderProps) {
  const { user, switchRole, selectedRole } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-gray-950/95 backdrop-blur border-b border-gray-800 z-30">
      <div className="flex items-center justify-between h-full px-4">
        <div className="flex items-center">
          <button
            onClick={toggleSidebar}
            className={clsx(
              'p-2 rounded-lg text-gray-400 hover:text-white lg:hidden',
              'hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-800'
            )}
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <h1 className="text-xl font-bold text-white ml-4">Nyedis All Seeing Eye</h1>          
        </div>
        <div className="flex items-center gap-4">
          <select
            value={selectedRole}
            onChange={(e) => switchRole(e.target.value as 'Executive' | 'Project Manager')}
            className="bg-gray-800 text-white rounded-lg px-3 py-1 border border-gray-700 focus:border-red-500 focus:ring-red-500"
          >
            <option value="Executive">Executive</option>
            <option value="Project Manager">Project Manager</option>
          </select>
          <Notifications />
        </div>
      </div>
    </header>
  );
}